<template>
    <v-menu v-model="isShowMenu" offset-y :close-on-content-click="false">
        <template v-slot:activator="{ on }">
            <v-text-field 
                v-model="varietyName"
                dense
                readonly 
                outlined 
                label="品種" 
                hint="クリックして品種を選択出来ます。" 
                persistent-hint
                prepend-icon="mdi-fruit-cherries"
                append-icon="mdi-menu-down"
                @click:append="isShowMenu=true"
                v-on="on" />
        </template>
            <v-list dense>
                <v-list-group v-for="crop in crops" :key="crop.body.cropID" no-action>
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title>{{crop.body.name}}</v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <v-list-item v-for="variety in crop.varieties" :key="variety.varietyID" @click="onSelectedItem(variety)">
                        <v-list-item-content>{{variety.name}}</v-list-item-content>
                    </v-list-item>
                </v-list-group>
            </v-list>
    </v-menu>
</template>

<script>
    export default {
        props: {
            value: {
                type: Object,
                default: null
            },
            crops: {
                type: Array,
                default: function() {
                    return []
                }
            },
        },
        data: function () {
            return {
                isShowMenu: false,
            }
        },
        computed: {
            varietyName: function () {
                if (this.variety == null) {
                    return ""
                }
                if (this.variety.name != null) {
                    return this.variety.name
                }
                for (var i=0; i<this.crops.length; i++) {
                    if (this.crops[i].body.cropID == this.variety.cropID) {
                        for (var j=0; j<this.crops[i].varieties.length; j++) {
                            if (this.crops[i].varieties[j].varietyID == this.variety.varietyID) {
                                return this.crops[i].varieties[j].name
                            }
                        }
                    }
                }
                return "unknown value"
            },
            variety: {
                get: function() {return this.$props.value},
                set: function(v) {
                    this.$emit("input", v)
                }
            }
        },
        created: function () {
            const self = this
            // for(var i=0; i<this.placeGroups.length; i++) {                
            //     const groupItem = {
            //         text: this.placeGroups[i].name,
            //         value: this.placeGroups[i].placeGroupID,
            //         group: this.placeGroups[i],
            //         children: []
            //     }
            //     self.menuItems.push(groupItem)
            //     self.places.forEach(function(place){
            //         if (place.placeGroupID != null && place.placeGroupID == self.placeGroups[i].placeGroupID) {
            //             const item = {
            //                 text: place.name,
            //                 value: place.placeID,
            //                 place: place,
            //             }
            //             groupItem.children.push(item)
            //         }
            //     })
            // }
            // this.places.forEach(function(place){
            //     if (place.placeGroupID == null || place.placeGroupID == '') {
            //         const item = {
            //             text: place.name,
            //             value: place.placeID,
            //             place: place,
            //         }
            //         self.menuItems.push(item)
            //     }
            // })
            // this.placeName = ""
        },
        methods: {
            onSelectedItem: function (item) {
                console.log("SelectorVariety", "onSelectedItem", item)
                this.isShowMenu = false
                this.variety = item
            }
        }
    }
</script>
